import styled from 'styled-components';

/** The positioned header content anchors the comparison hover tint on every breakpoint. */
export const ComparisonVehicleHeader = styled.div`
  position: relative;
`;
